import React from 'react';
import { getSeverityColor } from '../../../utils/severityColors';

interface SeverityCircleProps {
  score: number;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  tooltip?: string; // optional hover explanation
}

const SeverityCircle: React.FC<SeverityCircleProps> = ({ 
  score, 
  size = 'medium', 
  className = '',
  tooltip
}) => {
  
  // Get size classes
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return {
          container: 'w-12 h-12',
          text: 'text-base'
        };
      case 'medium':
        return {
          container: 'w-16 h-16',
          text: 'text-xl'
        };
      case 'large':
        return {
          container: 'w-32 h-32',
          text: 'text-5xl'
        };
      default:
        return {
          container: 'w-16 h-16',
          text: 'text-2xl'
        };
    }
  };
  
  const sizeClasses = getSizeClasses();
  const backgroundColor = getSeverityColor(score);
  
  return (
    <div 
      className={`${sizeClasses.container} rounded-full flex items-center justify-center shadow-lg ${className}`}
      style={{ backgroundColor }}
      title={tooltip}
    >
      <span 
        className={`${sizeClasses.text} font-bold text-white leading-none`}
        style={{ fontFamily: 'Open Sans, sans-serif' }}
      >
        {Math.round(score)}
      </span>
    </div>
  );
};

export default SeverityCircle;
